import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "./AnimalSighting.css";
import { t } from "i18next";

const AnimalModalPopups = ({forData, ...props }) => {
    return (
        <div id="" className="animalModalWrp">
            {
                forData === "deleteConfirm" &&
            (
                <Modal 
            {...props} 
            centered
            size="md">
                {
                    props.for === "deleteConfirm" && {}
                }
                <Modal.Body className="animalModalBody pb-0">
                        <h6 className="mb-3"><strong>{t("Delete Record")}</strong></h6>
                        <p className="mb-0">{t("DeleteMessage")}</p>
                        {/* <p className="mb-0">Are you sure you want to delete this record? This action cannot be undone</p> */}
                        {/* <p className="mb-0">Are you sure you want to delete record for <strong>{props.data}</strong>? This action cannot be undone</p> */}
                </Modal.Body>
                <Modal.Footer className="border-0 animalModalFooter">
                    <Button variant="outline" onClick={props.onClose}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary delete-btn" onClick={props.onConfirm}>
                        {t("delete")}
                    </Button>
                </Modal.Footer>
            </Modal>
            )
            }

{
                forData === "deleteSuccess" &&
            (
            
            <Modal 
            {...props} 
            centered
            size="sm">
                <Modal.Body className="animalModalBody text-center pb-0">
                    <div className="animalModalBodyIco">
                    <img src={`${process.env.PUBLIC_URL}/images/sucess-gif.gif`} />
                    </div>
                        <p className="mb-0">Record Deleted Successfully</p>
                </Modal.Body>
                <Modal.Footer className="border-0 animalModalFooter">
                    <Button variant="primary flex-fill" onClick={props.onClose}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
            )}
        </div>
    );

};

export default AnimalModalPopups;